module.exports = __webpack_public_path__ + "static/img/路径 2898.b49a69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inAndOut/cancelled/images/路径 2898.png
// module id = hyR9
// module chunks = 0